import { sinatraOrigin } from '../../config'

import keycloakService from '../../keycloak_service'

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const getLogsForTaskRun = (runId) => {
  const body = {
    id: runId
  }
  
  const fetchOptions = {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify(body)
  }

  return postToApi('v1/api/task/get_logs_for_run', fetchOptions)
}

export default getLogsForTaskRun
